import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { get, put, post } from "../../utils/apiUtils";
import { motion } from "framer-motion";
import CommonHexagonBadge from "./CommonHexagonBadge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGear,
  faPeopleGroup,
  faBell,
  faRobot,
  faPlug,
  faPlus,
  faMagnifyingGlass,
  faUserGroup,
  faAngleRight,
  faUserPlus,
  faUserShield,
  faFileLines,
  faCircleInfo,
  faFloppyDisk,
  faTrashCan
} from "@fortawesome/free-solid-svg-icons";
import { faBuilding, faCircleDown } from "@fortawesome/free-regular-svg-icons";
import {
  FormRow,
  FormGroup,
  Label,
  Input,
  Select,
  Button,
  ButtonGroup,
  SectionTitle,
  Modal,
  ModalContent,
  ModalHeader,
  CloseButton,
  Divider,
  ButtonSuccess,
  ButtonCreate,
  InfoContiner,
  SaveButton
} from "../../styles/PageStyles";
import { updateUserGroup } from "../../services/groupService";
import { createAccessControl, getAccessControlCount, getAccessControlData, getAccessPermissionType, getAccessResourceType, getDependencyTree, getGroupCount, getGroupsData, getResourcesData, removePermissonById } from "../../services/accessControlService";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "./ToastProvider";
import { MultiSelectDropdownSearch } from "./MultiSelectSearch";
import Pagination from "./Pagination";
import PopConfirm from "./popConfirm";
import { usePagination } from "../../hooks/usePagination";

const UserGroupMain = styled.div`
  display: grid;
  grid-template-columns: 3fr 7fr; /* Automatically splits remaining space into 30% and 70% */
  gap: 20px;
`;

const UserGroupMainLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
  width: auto;
`;

const GroupDashboard = styled.div`
  border-radius: 10px;
  background: #fff;
  box-shadow: 4px 4px 10px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid #E3E3E3;

  .GroupContentCardWrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(138px, 100%), 1fr));
    gap: 20px;
    width: 100%;
    margin: 20px;
    max-width: 56%;
    width: 100%;
  }

  .VerticleDottedDivider {
    border-left: 1px dashed rgb(209, 209, 209);
    display: block;
    width: 1px;
    height: 100%;
    position: relative;

    ::before {
      position: absolute;
      content: "";
      top: -1px;
      right: -13px;
      width: 25px;
      height: 15px;
      background-color: rgb(255, 255, 255);
      box-sizing: border-box;
      border-width: 1px 1px 0px;
      border-style: solid solid none;
      border-color: rgb(232, 234, 235);
      border-image: initial;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      transform: rotate(180deg);
      z-index: 1;
    }

    ::after {
      position: absolute;
      content: "";
      bottom: -1px;
      right: -13px;
      width: 25px;
      height: 15px;
      background-color: rgb(255, 255, 255);
      box-sizing: border-box;
      border-width: 1px 1px 0px;
      border-style: solid solid none;
      border-color: rgb(232, 234, 235);
      border-image: initial;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      transform: rotate(360deg);
      z-index: 1;
    }
  }
`;

const GroupContentCard = styled.div`
    display: flex;
    border-radius: 10px;
    background: #F5F7FB;
    width: clamp(145px, calc(-40px + 4.69vw), 180px);
    padding: clamp(16px, calc(16px + 0.31vw), 20px) clamp(12px, calc(16px + 0.31vw), 14px) clamp(16px, calc(16px + 0.31vw), 20px);
    justify-content: space-between;
    cursor: pointer;
    width: 100%;

    .GroupContentCardLeft {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
}
    .MemberCount {
    color: #151834;
    font-size: clamp(24px, 1vw, 32px);
    font-weight: 500;
}
    .MemberCaption
    {
    color: #151834;
    font-size: clamp(12px, 1vw, 14px);
    font-weight: 500;
    }

    .GroupContentCardRight {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items; right;

    .UserGroup {
    color: #8E9EBC;
    font-size: clamp(20px, 1vw, 26px);
}
    .AngleRight {
    background-color: #00A1FF0D;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    display: flex;
    padding: 7px 8px;
    height: unset;
    color: #4791FF;
    font-size: clamp(10px, 1vw, 18px);
}
}
`;

const GroupAccessWrapper = styled.div`
  border-radius: 10px;
  border: 1px solid #e3e3e3;
  background: #fff;
  box-shadow: 4px 4px 0 0 rgba(0, 0, 0, 0.02);
  display: flex;
  flex-wrap: wrap;
`;

const GroupAcessTree = styled.div`
  width: 50%;
  border-radius: 10px 0 0 10px;
  background: #233a67;
  box-shadow: 4px 4px 0 0 rgba(0, 0, 0, 0.02);
  color: #ffffff;

  .AccessPreviewHeader {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-weight: 700;
    border-bottom: 1px solid #3A4E77;
    padding: 2rem 3rem 1rem;
  }

  .AccessPreviewHeaderTitle {
    font-size: clamp(16px, 1vw, 20px);
  }

  .AccessPreviewHeaderSubtitle {
    font-size: clamp(12px, 1vw, 16px);
    color: #94A6CA;
  }

  .AccessPreviewContent {
    padding: 1rem 3rem 3rem 3rem;
  }

  .AccessPreviewContentTitle {
    font-size: clamp(12px, 1vw, 16px);
    font-weight: 400;
    margin-bottom: 0.5rem;
    padding-left: 0.5rem;
  }

  .AccessPreviewTree {
    position: relative;
    padding-left: 0.5rem;
  }

  .AccessPreviewTree::before {
    content: "";
    position: absolute;
    left: 8px;
    top: 0;
    bottom: 0;
    width: 10px;  
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.86) 0%, rgba(255, 255, 255, 0.86) 50%, transparent 50%, transparent 100%);
    background-size: 1px 30px; 
    background-repeat: repeat-y;
  }

  .AccessPreviewList {
    list-style-type: none;
    margin: 0;
    padding: 0 0 0 24px;
  }

  .AccessPreviewList > li {
    position: relative;
    line-height: 24px;
    padding-left: clamp(20px, 3vw, 50px);
    padding-top: 1.57rem;
    color: #ffffffdb;
  }

  .AccessPreviewList > li::before {
    content: "├────";
    position: absolute;
    left: -12px;
    color: rgba(255, 255, 255, 0.86);
    font-size: clamp(12px, 1vw, 16px);
  }

  .AccessPreviewNestedList {
    list-style-type: none;
    margin: 0;
    padding: 0;
    position: relative;
    left: -17px;
    top: 5px;
  }

  .AccessPreviewNestedList::before {
    content: "";
    position: absolute;
    left: 8px;
    top: 0;
    bottom: 12px; 
    width: 10px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.86) 0%, rgba(255, 255, 255, 0.86) 40%, transparent 40%, transparent 100%);
    background-size: 1px 24px; 
    background-repeat: repeat-y;
    display: none;
  }

  .AccessPreviewNestedList li {
    position: relative;
    line-height: 24px;
    padding-left: clamp(50px, 4vw, 70px);
    color: rgba(255, 255, 255);
    color: #ffffffdb;
  }

  .AccessPreviewNestedList li::before {
    content: "├────";
    position: absolute;
    left: 0px;
    color: rgba(255, 255, 255, 0.86);
    font-size: clamp(12px, 1vw, 16px);
  }
  
  // .AccessPreviewNestedList li:last-child::before {
  //   content: "└──"; 
  // }
`;

const TreeEmptySection = styled.div`
  width: 50%;
  border-radius: 10px 0 0 10px;
  box-shadow: 4px 4px 0 0 rgba(0, 0, 0, 0.02);
  color: #ffffff;
`


const ResourcePermission = styled.div`
  display: flex;
  flex-direction: column;
    padding: clamp(40px, -40px + 4.69vw, 50px);
    width: 50%;
    gap: clamp(40px, -40px + 4.69vw, 50px);

    .ResourcePermissionHeader
    {
      display: flex;
      justify-content: space-between;
      color: #858B96;
      font-size: clamp(12px, 1vw, 14px);
      font-weight: 500;
    }

    .ResourcePermissionForm
    {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .FormWrap
      {
      display: flex;
      flex-direction: column;
      gap: 6px;

        .FormWrapLabel
        {
          color: #858B96;
          font-size: clamp(12px, 1vw, 16px);
          font-weight: 500;
        }

      .selectBoxWrapper
  {
      position: relative;
      width: 100%;
      max-width: 220px;
      min-width: 190px;
}
      .selectBoxWrapper::before
  {
  position: absolute;
  content: "";
      right: 11px;
    top: 18px;
    width: 11px;
    height: 6px;
  background-image: url("./images/down-arrow.svg");
  background-repeat: no-repeat;
  z-index: 1;
  }
}
    .formSelectBox
        {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 190px;
  box-sizing: border-box;
  font-size: clamp(14px, 1vw, 16px);
  padding: 10px 13px;
  background-color: #ffffff;
  border: 1px solid #E0E6F0; 
  border-radius: 5px;         
  color: #404040;
  cursor: pointer;
      
  }

      }
    }

 
  .ActionsTitle {
    font-size: clamp(14px, 1vw, 20px);
    font-weight: 600;
    color: #8a92a6;
    margin-bottom: 12px;
  }

  .CheckboxGrid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .FormGroupWrapper
    {
    margin: 0;
    }
  }

  /* Hidden Native Checkbox */
  .CheckboxCard input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* Button Card Wrapper Styling */
  .CheckboxCard {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    cursor: pointer;
    user-select: none;
    /* Smooth scale/border transition for hovering */
    transition:
      border-color 0.25s ease,
      transform 0.15s ease,
      box-shadow 0.25s ease;
  }

  /* Card Hover States */
  .CheckboxCard:hover {
    border-color: #cbd5e1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  }

  .CheckboxCard:active {
    transform: scale(0.98);
  }

  /* Text Label Styling */
  .CheckboxLabel {
    font-size: clamp(12px, 1vw, 16px);
    color: #334155;
    font-weight: 500;
  }

  /* Custom Checkbox Square Box */
  .CheckboxBox {
    position: relative;
    width: 16px;
    height: 16px;
    border: 1px solid #94a3b8;
    border-radius: 4px;
    background-color: #ffffff;
    /* Smooth background color flip */
    transition:
      background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1),
      border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* Checkmark Graphic using CSS Pseudo-Element */
  .CheckboxBox::after {
    content: "";
    position: absolute;
    left: 5px;
    top: 1px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg) scale(0.5);
    opacity: 0;
    /* Smooth scale-up fade effect for the checkmark symbol */
    transition:
      transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1),
      opacity 0.15s ease;
  }

  /* STATE: Checked Elements Styling */
  .CheckboxCard input:checked ~ .CheckboxBox {
    background-color: #0099ff;
    border-color: #0099ff;
  }

  .CheckboxCard input:checked ~ .CheckboxBox::after {
    opacity: 1;
    transform: rotate(45deg) scale(1);
  }

  /* Focus Indicator for Accessibility */
  .CheckboxCard input:focus-visible ~ .CheckboxBox {
    outline: 2px solid #0099ff;
    outline-offset: 2px;
  }
  .infoTitle {
    color: #404040;
    font-size: clamp(11px, calc(-1px + 0.94vw), 17px);
    font-weight: 700;
  }
`;

const GroupRulesWrapper = styled.div`

/* Card Container Layout */
.TableContainer {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  width: 100%;
  margin: 20px auto;
  border: 1px solid #E3E3E3;
}

/* Header & Search Alignment */
.TableHeaderRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.TableHeaderRow h2 {
  font-size: clamp(16px, 1vw, 20px);
  color: #333;
  margin: 0;
}

.SearchBox
{
position: relative;
width: 350px;
}

.SearchBox input {
  width: 100%;
  padding: 8px 12px 8px 38px;
  border-radius: 5px;
  font-size: clamp(12px, 1vw, 16px);
  background-color: #F7F7F7;
  border: transparent;
}

.SearchBox input:focus
{
  border: transparent;
  outline: transparent;
}

.RulesTable {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: clamp(12px, 0.8vw, 16px);
  font-weight: 600;
  color: #404040;
}

.RulesTable th {
      background-color: #F3F5F7;
    color: #404040;
    font-weight: 600;
    padding: 12px 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #dbdbdb;
}

.RulesTable td {
  padding: 18px 16px;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}

.RulesTable tr.HighlightRow td {
  background-color: #F2F7FD;
}

.Chip {
  background-color: #f1f5f9;
  color: #475569;
  height: 25px;
  border-radius: 20px;
  font-size: clamp(12px, 0.8vw, 16px);
  font-weight: 500;
  margin-right: 7px;
  padding: 0 11px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.TextRight {
  text-align: right !important;
}

.ActionButtons
{
    display: flex;
    align-items: center;
    gap: 2rem;
}

.ActionButtons button {
  border: transparent;
  display: flex;
  align-items: center;
  gap: 7px;
  font-weight: 700;
}

.BtnEdit {
  color: #475569;
  background-color: transparent;
  font-size: clamp(12px, 0.8vw, 16px);
}

.BtnEdit:hover {
  color: #000;
}

.BtnEditIcon 
{
    background-color: #4040400D;
    border-radius: 50%;
    padding: 9px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.BtnDelete
{
   background-color: #FF43520D;
    border-radius: 50%;
    padding: 9px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #FF4352;
    font-size: clamp(12px, 1vw, 16px);
}

.BtnDelete:hover {
  opacity: 1;
}


`;

const SearchInputWrapper = styled.div`
  position: relative;
`;

const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

const Card = styled.div`
  position: relative;
  background: ${(props) =>
    props.active ? "rgba(0, 161, 255, 0.05);" : "#FFFFFF"};
  border: 1px solid ${(props) => (props.active ? "#007FFF" : "#EAECEF")};
  border-radius: 5px;
  padding: 16px 20px;
  cursor: pointer;
  overflow: hidden; /* Keeps the sliding background layer within the card bounds */
  transition:
    border-color 0.4s ease,
    background-color 0.4s ease,
    transform 0.2s ease;

  /* The left blue indicator bar for active state */
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background-color: #007fff;
    opacity: ${(props) => (props.active ? 1 : 0)};
    transition: opacity 0.3s ease;
  }
  /* Smooth left-to-right sliding hover effect layer */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(0, 127, 255, 0.04) 0%,
      rgba(0, 127, 255, 0) 100%
    );
    transform: translateX(-100%); /* Starts completely hidden on the left */
    transition: transform 0.4s cubic-bezier(0.25, 1, 0.5, 1);
    z-index: 0; /* Keeps the tint behind your text and icons */
    pointer-events: none;
    border-left: 3px solid #00a1ff;
  }
  &:hover {
    border-color: #007fff;
    background: rgba(0, 161, 255, 0.05);
    transform: translateY(-1px); /* Slight lift feeling */

    &::before {
      transform: translateX(
        0
      ); /* Slides fluidly to the right covering the card */
    }
    .faAngleRight,
    .faUserGroup {
      color: #007fff;
    }
  }
  .GroupName {
    font-weight: 700;
  }
  .Membercount {
    font-weight: 500;
    margin: 0;
    .MemberCountLenght {
      font-weight: 700;
    }
  }

  .faUserGroup {
    stroke-width: 1.5px;
    stroke: #b1b5bf;
    color: rgb(177, 181, 191);
  }

  .faAngleRight {
    margin-left: auto;
    stroke-width: 1.5px;
    stroke: #b1b5bf;
    color: rgb(177, 181, 191);
  }
`;
const CardTitle = styled.div`
  display: flex;
  gap: 1.25rem;
  align-items: center;
`;
const SearchIcon = styled(FontAwesomeIcon)`
  position: absolute;
  left: 17px;
  color: rgb(160, 160, 160);
  font-size: clamp(14px, calc(7px + 0.94vw), 16px);
  pointer-events: none;
  top: 50%;
  transform: translateY(-50%);
`;

const SearchInput = styled(Input)`
  border-radius: 5px;
  background: #f7f7f7;
  border: transparent;
  padding: 15px 15px 15px 45px;
  color: var(--grey-main);
  font-size: clamp(12px, 1vw, 14px);
  font-style: normal;
  font-weight: 600;
  width: fix;
`;

const UserGroupWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8rem;
`;

const Title = styled.h1`
  font-size: clamp(1rem, 1vw, 1.3rem);
  font-weight: 700;
  color: var(--text-color-main);
`;

const GroupDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const GroupDetail = styled.div`
  display: flex;
  gap: 16px;
  padding: clamp(20px, 1vw, 22px);
  width: 40%;

  .UserGroupIcon {
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #00a1ff0d;
    height: fit-content;
    color: var(--primary-500);
  }

  .UserGroupType {
    border-radius: 20px;
    color: var(--text-color-main);
    background-color: rgb(245, 245, 245);
    padding: 8px 10px;
    width: fit-content;
    font-size: clamp(12px, 1vw, 14px);
    font-weight: 500;
  }

  .UserGroupMembers {
    color: var(--primary-500);
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 2rem;
    margin-top: 14px;
    flex-wrap: wrap;
    row-gap: 10px;
    margin-top: 14px;

    .ViewAllMembers {
      color: #00a1ff;
      font-size: clamp(12px, 1vw, 14px);
      font-weight: 700;
      cursor: pointer;
    }
  }

  .AddMember {
    border-radius: 50px;
    background: rgba(0, 161, 255, 0.05);
    color: #00a1ff;
    font-size: clamp(12px, 1vw, 14px);
    font-weight: 600;
    padding: 6px 14px;
    border: transparent;
  }
`;

const Toggle = styled.div`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
`;

const ToggleInput = styled.input`
  opacity: 1;
  width: 20px;
  height: 20px;

  &:checked + span {
    background: var(--gradient-primary);
  }

  &:checked + span:before {
    transform: translateX(24px);
  }
`;

export const TreeContainer = styled.div`
  padding: 12px 0 12px 18px;
`;

export const TreeItem = styled.div`
  position: relative;
  padding-left: 22px;

  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: -2px;
    bottom: 0;
    width: 1px;
    background: rgba(255,255,255,.35);
  }

  &:last-child:before {
    bottom: calc(100% - 20px);
  }
`;

export const TreeLabel = styled.div`
  position: relative;
  color: #fff;
  font-size: 14px;
  line-height: 28px;
  font-weight: 500;

  &:before {
    content: "";
    position: absolute;
    left: -22px;
    top: 14px;
    width: 16px;
    height: 1px;
    background: rgba(255,255,255,.35);
  }
`;

export const TreeChildren = styled.div`
  margin-left: 22px;
`;

export const userGroupStyles  = {
  SelectedResource: { background: 'red' },
  SelectedSpan: { color: '#404040' },
  SelectedItem: {
    margin: '0', background: 'none',
    fontSize: '14px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    padding: '0'
  },
  SelectedRemoveBtn: {
    display: 'none'
  },
  SelectDropDown: {
    margin: '0',
    padding: '11px 30px 11px 13px',
    border: '1px solid rgb(224, 230, 240)',
    borderRadius: '5px'
  },
  selectedDropdownValue:
  {
    overflow: 'hidden'
  },
  DropdownIcon: {
    display: 'none'
  },
  MainDropdown: 
  {
    width: 'max-content',
  }
};

const TreeNode = ({ node }) => {
  return (
    <TreeItem>
      <TreeLabel>{node.name} 
        <span style={{fontSize:'12px', paddingLeft:'6px'}}>[{node.type}]</span>
      </TreeLabel>

      {node.children?.length > 0 && (
        <TreeChildren>
          {node.children.map((child, index) => (
            <TreeNode
              key={`${child.name}-${index}`}
              node={child}
            />
          ))}
        </TreeChildren>
      )}
    </TreeItem>
  );
};


const capitalize = (str) => (!str ? "" : str.charAt(0).toUpperCase() + str.slice(1));
const resourceTypeToConfigMap = {
  "agents" : "agent",
  "knowledgebase" : "knowledgebase",
  "planners" : "planner",
  "entity": "entities",
  "prompt": "prompt",
  "pipeline": "pipeline",
}

const UserGroups = ({ onSelectGroup , onSelectUser}) => {
  const [userGroupsList, setUserGroupsList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedGroupIdx, setSelectedGroupIdx] = useState(0);
  const [accessControlCount, setAccessControlCount] = useState(0);
  const [resourcePermissionForm, setResourcePermissionForm] = useState({componentType: "", selectiveComponentCd: "", effect: "",  permissionTypes: []});
  const [componentTypeOp, setComponentTypeOp] = useState([]);
  const [resourceTypeOp, setResourceTypeOp] = useState([]);
  const [permissionTypesOp, setPermissionTypeOp] = useState([]);
  const [treeViewData, setTreeViewData] = useState([]);
  const [accessControlData, setAccessControlData] = useState({});
  const [configApiMapData, setConfigApiMapData] = useState([]);

  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const accessControlRef = useRef(null);
  const groupPagination = usePagination();

  const { user } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const GROUP_PAGE_SIZE = 10;
  const fetchUserGroups = async () => {
    try {
      const filter = {};
      const sort = {};
      const query = {skip: (groupPagination?.currentPage - 1) *GROUP_PAGE_SIZE , limit: GROUP_PAGE_SIZE}
      const response = await getGroupsData(filter, sort, query);
      setUserGroupsList(response);
    } catch (error) {
      console.error("Error fetching user groups:", error);
    }
  };

  useEffect(() => {

    const fetchPermissionTypes = async () => {
      try {
        const responce = await getAccessPermissionType();
        setPermissionTypeOp(responce || [])
      } catch (error) {
        console.log("Error fetching component types:", error)
      }
    }

    const fetchComponentTypes = async () => {
      try {
        const responce = await getAccessResourceType();
        setComponentTypeOp(responce || [])
      } catch (error) {
        console.log("Error fetching component types:", error)
      }
    }

    const fetchGroupCount = async () => {
      const resp = await getGroupCount();
      if(resp) {
        groupPagination?.setToatalItems(resp || 0);
      }
    }

    fetchUserGroups();
    fetchPermissionTypes();
    fetchComponentTypes();
    fetchAccessControleData();
    fetchGroupCount();
  }, [navigate]);


  useEffect(() => {
    groupPagination?.setCurrentPage(1);
  },[])

    useEffect(() => {
      fetchUserGroups()
    }, [groupPagination?.currentPage])


  const fetchAccessControleData = async () => {
    try {
      const filter = {entity_id: userGroupsList[selectedGroupIdx]?.group}
      const query = {skip: 0, limit: accessControlCount}
      const responce = await getAccessControlData(filter, query);
      setAccessControlData(responce)
    } catch (error) {
      console.log("Error fetching the access control:", error);
    }
  }

  const fetchAccessControlCount = async () => {
    try {
      const filter = {entity_id: userGroupsList[selectedGroupIdx]?.group}
      console.log("Access control count filter : ", filter)
      const resp = await getAccessControlCount(filter);
      setAccessControlCount(resp || 0);
    } catch (error) {
      console.log("Error fetching the access control count", error);
    }
  }


  useEffect(() => {
    fetchAccessControlCount();
  }, [selectedGroupIdx, userGroupsList]);

  useEffect(() => {
     fetchAccessControleData();
  }, [accessControlCount])


useEffect(() => {
  const componentTypes = [
    "agent",
    "knowledgebase",
    "planner",
    "entities",
    "prompt",
    "pipeline",
  ];

  const queryParams = {
    skip: 0,
    limit: 500,
  };

  const fetchDependencies = async () => {
    const results = await Promise.allSettled(
      componentTypes.map((componentType) =>
        getResourcesData(componentType, {}, {}, queryParams)
      )
    );

    const data = {};
    const errors = {};

    results.forEach((result, index) => {
      const componentType = componentTypes[index];

      if (result.status === "fulfilled") {
        data[componentType] = result.value;
      } else {
        errors[componentType] = result.reason;
        console.error(`Failed to fetch ${componentType}`, result.reason);
      }
    });
    setConfigApiMapData(data);

    // setResources(data);
  };

  fetchDependencies();
}, []);

  const fetchResourceData = async () => {
    setResourceTypeOp([]);  
    try {
      const tableName = resourceTypeToConfigMap[resourcePermissionForm.componentType] || resourcePermissionForm.componentType;
      const queryParams = { skip: 0, limit: 500 }
      const resp = await getResourcesData(tableName, {}, {}, queryParams);
      if (resp.length) {
        setResourceTypeOp(resp);
      }
    } catch (error) {
      console.log("Error fetching the resource data:", error)
    }
  }

  const fetchDependencyView = async (componentType, componentCode) => {
    try {
      const resp = await getDependencyTree(componentType, componentCode);
      if(resp.dependencies) {
        setTreeViewData(resp)
      }
    } catch (error) {
      console.log("Error fetching the dependency view:", error)
    }
  }



  useEffect(() => {
  if(resourcePermissionForm.componentType) {
  fetchResourceData();
  }
  },[resourcePermissionForm.componentType])

  useEffect(() => {
    if(resourcePermissionForm.componentType && resourcePermissionForm.selectiveComponentCd) {
      const map = {
       'agents' :'agent',
       'knowledgebase': 'knowledgebase',
       'planners': 'planner',
       'entity': 'entity',
       'prompt' : 'prompt',
       'pipeline': 'pipeline'
      }
      const compType = map[resourcePermissionForm.componentType] || resourcePermissionForm.componentType;
      fetchDependencyView(compType, resourcePermissionForm.selectiveComponentCd);
    }
  }, [resourcePermissionForm.componentType, resourcePermissionForm.selectiveComponentCd])

  const handleToggleChange = async (group) => {
    group.status = group.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
    updateGroup(group);
  };
  const updateGroup = async (group) => {
    try {
  
      const response = await updateUserGroup(group);

      setUserGroupsList((prevGroups) =>
        prevGroups.map((g) =>
          g.id === group.id ? { ...g, status: response.status } : g,
        ),
      );
    } catch (error) {
      console.error("Error updating group status:", error);
    }
  };

  const handleEffechChange = (value) => {
    setResourcePermissionForm((prev) => {
      return {
        ...prev,
        permissionTypes : prev.permissionTypes.map((item) => ({...item, effect: value }))
      }
    })
  }

  const handlePermissionCheckboxChange = (e) => {
  const permissionValue = e.target.value; 
  
  setResourcePermissionForm((prev) => {
    const isChecked = prev.permissionTypes.some(
      (item) => item.permission_type === permissionValue
    );

    let updatedPermissions;

    if (isChecked) {
      updatedPermissions = prev.permissionTypes.filter(
        (item) => item.permission_type !== permissionValue
      );
    } else {
      const newPermissionPayload = {
        effect: prev.effect || "ALLOW",
        entity_type: "group",
        entity_id: userGroupsList[selectedGroupIdx]?.group || "",
        company_cd: user?.companyCd || "MMS",
        component_type: prev.componentType,
        selective_component_cd: prev.selectiveComponentCd || "",
        permission_type: permissionValue, 
        code_block: {
          lang: "python",
          code_block: ""
        }
      };

      updatedPermissions = [...prev.permissionTypes, newPermissionPayload];
    }

    return {
      ...prev,
      permissionTypes: updatedPermissions
    };
  });
};

const handleDeletePermission = async (permission) => {
  if (!permission?.permissionTypes?.length) return;
  const permissionCount = permission?.permissionTypes?.length;

  const results = await Promise.allSettled(
    permission.permissionTypes.map(({ id }) => removePermissonById(id))
  );

  const success = [];
  const failed = [];

  results.forEach((result, index) => {
    const { id } = permission.permissionTypes[index];

    if (result.status === "fulfilled") {
      success.push(id);
    } else {
      failed.push({
        id,
        error: result.reason,
      });
    }
  });


  if (failed.length) {
    showToast({
      type: "error",
      message:"Something went wrong deleting the permissions."
    })
  } else {
    showToast({
      type: "success",
      message:"Permission deleted successfully."
    });
    fetchAccessControleData();
    setCurrentPage(1)
  }
};



  const handleSavePermission = async () => {
    try {
      if (!resourcePermissionForm.permissionTypes.length || !resourcePermissionForm.componentType) {
        showToast({
          message: "Please select the mandatory fields.",
          type: "error"
        })
        return;
      }

      const resp = await createAccessControl(resourcePermissionForm.permissionTypes);
      if(resp.length) {
        showToast({
          message: "Permissions successfully added.",
          type: "success"
        })
        fetchAccessControleData();
        fetchAccessControlCount();
        setResourcePermissionForm({componentType: "", selectiveComponentCd: "", effect: "", permissionTypes: []})
        setTreeViewData([]);
        setResourceTypeOp([])
      }
    } catch (error) {
      console.log("Error creating a access control", error)
    }

  }

  const filteredGroups = userGroupsList.filter((item) =>
    item?.group?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

const tableRows = useMemo(() => {
  if (!accessControlData.length) return [];

  const groupedRules = Object.groupBy(accessControlData, (rule) => {
    return `${rule.component_type}_${rule.selective_component_cd}_${rule.effect}`;
  });

  return Object.values(groupedRules).map((permissions) => {
    const {
      component_type,
      selective_component_cd,
      effect,
    } = permissions[0];

    return {
      componentType: component_type || "Pipeline",
      resource: selective_component_cd || "",
      permissionTypes: permissions,
      effect,
    };
  });
}, [accessControlData]);


const startIndex = itemsPerPage * (currentPage - 1);
const endIndex = startIndex + itemsPerPage;

const filteredTableRow = tableRows.slice(startIndex, endIndex);


    useEffect(() => {
    setTotalItems(tableRows?.length || 0)
  }, [tableRows?.length])




  const handleEditPermission = (permission) => {
    console.log("permission :",permission)
    if (permission) {
      const newPayload = {...permission, selectiveComponentCd: permission?.resource, effect: permission?.effect}
      setResourcePermissionForm(newPayload);
      accessControlRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  const handleViewPermissionRules = () => {
        accessControlRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
  }

  const getResourceName = (componentType, code) => {
    if(Object.keys(configApiMapData).length) {

   const resource = configApiMapData[resourceTypeToConfigMap[componentType]] ? 
   configApiMapData[resourceTypeToConfigMap[componentType]].find((item) => item.code == code) : null;

   if(resource && resource?.name) {
    return resource.name
   } else {
    return code;
   }
  } else {
    return code;
  }
  }

  return (
    <>
      <UserGroupMain ref={accessControlRef}> 
        <UserGroupMainLeft>
          <UserGroupWrapper>
            <Title>User Groups</Title>
            <ButtonCreate onClick={() => onSelectGroup(null, true)}>
              <FontAwesomeIcon icon={faPlus} />
              New Group
            </ButtonCreate>
          </UserGroupWrapper>
          <SearchInputWrapper>
            <SearchIcon icon={faMagnifyingGlass} />
            <SearchInput
              type="text"
              placeholder="Search groups..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </SearchInputWrapper>

          <CardsWrapper>
            {filteredGroups.map((groupItem, index) => (
              <Card key={`${groupItem?.group}_${index}`} active={selectedGroupIdx == index} onClick={() => setSelectedGroupIdx(index)}>
                <CardTitle>
                  <FontAwesomeIcon
                    className="faUserGroup"
                    icon={faUserGroup}
                    style={{ cursor: "pointer" }}
                  />

                  <div
                    onClick={() => {}}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="GroupName">{groupItem?.group}{groupItem?.id}</div>
                    <p className="Membercount">
                      <span className="MemberCountLenght">{groupItem?.number_of_users}</span> Members
                    </p>
                    {/*  <p>{group.description}</p> */}
                  </div>

                  <FontAwesomeIcon
                    className="faAngleRight"
                    icon={faAngleRight}
                  />
                  {/* <div style={{ marginLeft: 'auto', display: 'flex', gap: '1rem', alignItems: 'center' }}>
                                <Toggle>
                                    <ToggleInput
                                        type="checkbox"
                                        checked={group.status === "ACTIVE"}
                                        onChange={async () => {
                                            await handleToggleChange(group);
                                        }}
                                    />
                                </Toggle>
                            </div> */}
                </CardTitle>
              </Card>
            ))}
                <Pagination
                        currentPage={groupPagination?.currentPage}
                        totalPages={groupPagination?.totalPages}
                        totalCount={groupPagination?.totalItems}
                        setCurrentPage={groupPagination?.setCurrentPage}
                        setTotalPages={groupPagination?.setTotalPages}
                        pageSize={GROUP_PAGE_SIZE}
                      />
          </CardsWrapper>
        </UserGroupMainLeft>
        <GroupDetailWrapper>
          <GroupDashboard>
            <GroupDetail>
              <span className="UserGroupIcon">
                <FontAwesomeIcon className="faUserGroup" icon={faUserGroup} />
              </span>

              <div className="UserGroupDetails">
                <Title>{userGroupsList[selectedGroupIdx]?.group}</Title>
                <h6 className="UserGroupType">{userGroupsList[selectedGroupIdx]?.desc ? userGroupsList[selectedGroupIdx]?.desc : userGroupsList[selectedGroupIdx]?.group}</h6>

                <div className="UserGroupMembers">
                  {
                  userGroupsList[selectedGroupIdx]?.number_of_users > 0 && <span className="ViewAllMembers" onClick={() => onSelectGroup(userGroupsList[selectedGroupIdx], false)}>
                    View All Members{" "}
                    <FontAwesomeIcon
                      className="faAngleRight"
                      icon={faAngleRight}
                    />
                  </span>
                  }
                  <button className="AddMember" onClick={() => {
                    onSelectUser({}, userGroupsList[selectedGroupIdx]);
                    }}>
                    <FontAwesomeIcon icon={faUserPlus} /> Add Member
                  </button>
                </div>
              </div>
            </GroupDetail>

            <div className="VerticleDottedDivider"></div>

            <div className="GroupContentCardWrapper">
              <GroupContentCard>
                <div className="GroupContentCardLeft">
                  <span className="MemberCount">{userGroupsList[selectedGroupIdx]?.number_of_users || 0}</span>
                  <span className="MemberCaption">Members</span>
                </div>
                <div className="GroupContentCardRight">
                  <span className="UserGroup">
                    <FontAwesomeIcon icon={faUserGroup} />
                  </span>
                  <span className="AngleRight" onClick={() => onSelectGroup(userGroupsList[selectedGroupIdx], false)}>
                    <FontAwesomeIcon icon={faAngleRight} />
                  </span>
                </div>
              </GroupContentCard>

              <GroupContentCard>
                <div className="GroupContentCardLeft">
                  <span className="MemberCount">{userGroupsList[selectedGroupIdx]?.roles?.length || 0}</span>
                  <span className="MemberCaption">Roles in Group</span>
                </div>
                <div className="GroupContentCardRight">
                  <span className="UserGroup">
                    <FontAwesomeIcon icon={faUserShield} />
                  </span>
                  <span className="AngleRight">
                    <FontAwesomeIcon icon={faAngleRight} />
                  </span>
                </div>
              </GroupContentCard>

              <GroupContentCard>
                <div className="GroupContentCardLeft">
                  <span className="MemberCount">{accessControlCount}</span>
                  <span className="MemberCaption">Configured Rules</span>
                </div>
                <div className="GroupContentCardRight">
                  <span className="UserGroup">
                    <FontAwesomeIcon icon={faFileLines} />
                  </span>
                  <span className="AngleRight" onClick={handleViewPermissionRules}>
                    <FontAwesomeIcon icon={faAngleRight} />
                  </span>
                </div>
              </GroupContentCard>
            </div>
          </GroupDashboard>
          <GroupAccessWrapper>
            <GroupAcessTree>

              <header className="AccessPreviewHeader">
                <span className="AccessPreviewHeaderTitle">Effective Access Preview</span>
                <span className="AccessPreviewHeaderSubtitle">Dependency View</span>
              </header>

              {/* <section className="AccessPreviewContent">

                <div className="AccessPreviewContentTitle">
                  {treeViewData?.name}
                </div>

                <div className="AccessPreviewTree">

                  <ul className="AccessPreviewList">

                    <li>[Agent]

                      <ul className="AccessPreviewNestedList">
                        <li>id</li>
                        <li>company_cd</li>
                        <li>created_at</li>
                        <li>updated_at</li>
                        <li> created_by</li>
                        <li>updated_by</li>
                        <li>code</li>
                      </ul>

                    </li>

                    <li>Prompt

                      <ul className="AccessPreviewNestedList">
                        <li>example_conversation[]</li>
                        <li>company_cd</li>
                        <li>updated_by</li>
                      </ul>

                    </li>

                  </ul>

                </div>


              </section> */}
              {!treeViewData?.dependencies && (
                <div style={{paddingLeft:'48px', paddingTop:'32px'}}>
                  <span>
                    After selecting the resource type and resource,
                  </span>
                  <br />
                  <span>
                      the corresponding details will be displayed below.
                  </span>
                </div>
              )}

              <section className="AccessPreviewContent">
                <div className="AccessPreviewContentTitle">
                  {treeViewData?.name}
                </div>

                <TreeContainer>
                  {treeViewData?.dependencies?.map((item, index) => (
                    <TreeNode
                      key={`${item.name}-${index}`}
                      node={item}
                    />
                  ))}
                </TreeContainer>
              </section>

            </GroupAcessTree>

            <ResourcePermission>
              <div className="ResourcePermissionHeader">
                <Title>Resource Permission</Title>
                Group-based access rules
              </div>
              <div className="ResourcePermissionForm">
                <FormGroup className="FormWrap">
                  <label className="FormWrapLabel">*Resource Type</label>
                  <div className="selectBoxWrapper">
                    <select className="formSelectBox" 
                            value={resourcePermissionForm.componentType}
                            onChange={(e) => setResourcePermissionForm((prev) => ({ ...prev, componentType: e.target.value }))}>
                      <option value="">Select</option>
                      {
                        componentTypeOp.length > 0 && componentTypeOp.map((option) => {
                          return <option key={option.id}
                            value={option?.code}
                          >
                            {option?.name}</option>
                        })
                      }
                    </select>
                  </div>                 
                </FormGroup>
                <FormGroup className="FormWrap">
                  <label className="FormWrapLabel">Resource</label>
                  <div className="selectBoxWrapper">
                    {/* <select className="formSelectBox" 
                            value={resourcePermissionForm.selectiveComponentCd}
                            onChange={(e) => setResourcePermissionForm((prev) => ({...prev, selectiveComponentCd: e.target.value}))}>
                    <option value="">Select</option>
                    {
                      resourceTypeOp.length > 0 && resourceTypeOp.map((res) => {
                        return <option key={res.id} value={res?.code}>{res?.name}</option>
                      })
                    }

                  </select> */}

                         <MultiSelectDropdownSearch
                                    options={resourceTypeOp}
                                    selected={resourcePermissionForm.selectiveComponentCd
                                                ? resourceTypeOp.filter((p) => p.code === resourcePermissionForm.selectiveComponentCd)
                                                : []}
                                    onChange={(newSelectedValue) => {
                                      setResourcePermissionForm((prev) => ({...prev, selectiveComponentCd: newSelectedValue[0]?.code || ""}))}
                                    }
                                    placeholder={"Select Resource"}
                                    displayKey="name"
                                    valueKey="name"        
                                    isSingleSelect={true}
                                    customStyles={userGroupStyles}
                                  />
                  </div>       
                </FormGroup>
                <FormGroup className="FormWrap">
                  <label className="FormWrapLabel">*Effect Type</label>
                  <div className="selectBoxWrapper">
                    <select className="formSelectBox" 
                            value={resourcePermissionForm.effect}
                            onChange={(e) => setResourcePermissionForm((prev) => {
                              const newData = { ...prev, effect: e.target.value }
                              handleEffechChange(e.target.value )
                              return newData
                            })}>
                      <option value="">Select</option>
                      <option value="ALLOW">Allow</option>
                      <option value="DENY">Deny</option>
                      
                    </select>
                  </div>                 
                </FormGroup>
              </div>
              <div className="ActionsContainer">
                <div className="ActionsTitle">Actions</div>

                <div className="CheckboxGrid">
                  <FormGroup className="FormGroupWrapper">
                    <label className="CheckboxCard">
                      <input
                        type="checkbox"
                        value="read"
                        checked={resourcePermissionForm.permissionTypes.some(
                          (item) => item.permission_type === "read"
                        )}
                        onChange={handlePermissionCheckboxChange}
                      />
                      <span className="CheckboxBox"></span>
                      <span className="CheckboxLabel">Read</span>
                    </label>
                  </FormGroup>

                  <FormGroup className="FormGroupWrapper">
                    <label className="CheckboxCard">
                      <input
                        type="checkbox"
                        value="execute"
                        checked={resourcePermissionForm.permissionTypes.some(
                          (item) => item.permission_type === "execute"
                        )}
                        onChange={handlePermissionCheckboxChange}
                      />
                      <span className="CheckboxBox"></span>
                      <span className="CheckboxLabel">Execute</span>
                    </label>
                  </FormGroup>

                  <FormGroup className="FormGroupWrapper">
                    <label className="CheckboxCard">
                      <input
                        type="checkbox"
                        value="create"
                        checked={resourcePermissionForm.permissionTypes.some(
                          (item) => item.permission_type === "create"
                        )}
                        onChange={handlePermissionCheckboxChange}
                      />
                      <span className="CheckboxBox"></span>
                      <span className="CheckboxLabel">Create</span>
                    </label>
                  </FormGroup>

                  <FormGroup className="FormGroupWrapper">
                    <label className="CheckboxCard">
                      <input
                        type="checkbox"
                        value="update"
                        checked={resourcePermissionForm.permissionTypes.some(
                          (item) => item.permission_type === "update"
                        )}
                        onChange={handlePermissionCheckboxChange}
                      />
                      <span className="CheckboxBox"></span>
                      <span className="CheckboxLabel">Update</span>
                    </label>
                  </FormGroup>

                  <FormGroup className="FormGroupWrapper">
                    <label className="CheckboxCard">
                      <input
                        type="checkbox"
                        value="delete"
                        checked={resourcePermissionForm.permissionTypes.some(
                          (item) => item.permission_type === "delete"
                        )}
                        onChange={handlePermissionCheckboxChange}
                      />
                      <span className="CheckboxBox"></span>
                      <span className="CheckboxLabel">Delete</span>
                    </label>
                  </FormGroup>
                </div>
              </div>

              <InfoContiner>
                <span className="InfoIcon">
                  <FontAwesomeIcon icon={faCircleInfo} />
                </span>
                <div>
                  <h4 className="infoTitle">What the user will see</h4>
                  <p>
                    If resource-level access is enabled, the user sees only the
                    permitted resource. If it is not enabled. the submenu
                    actions apply to all resources under the selected module.
                  </p>
                </div>
              </InfoContiner>

              <SaveButton onClick={handleSavePermission}>
                <FontAwesomeIcon className="Icon" icon={faFloppyDisk} />
                Save Permissions
              </SaveButton>
            </ResourcePermission>
          </GroupAccessWrapper>
          <GroupRulesWrapper>

            <div className="TableContainer">
              <div className="TableHeaderRow">
                <Title>Existing Rules</Title>
                <div className="SearchBox">
                  <SearchIcon icon={faMagnifyingGlass} />
                  <input type="text" placeholder="Search groups, resource, action..." />
                </div>
              </div>

              <table className="RulesTable">
                <thead>
                  <tr>
                    <th>Resource Type</th>
                    <th>Resource</th>
                    <th>Permissions</th>
                    <th>Effect</th>
                    <th>Actions</th>
                    <th className="TextRight"></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTableRow.map((row, index) => {
                    return <tr key={`${row.componentType}_${index}`}>
                      <td>{capitalize(row?.componentType)}</td>
                      <td>{getResourceName(row.componentType, row?.resource).length > 25 ? getResourceName(row.componentType,row?.resource).substring(0, 25) + '...' : getResourceName(row.componentType,row?.resource)}</td>
                      <td>
                        { 
                          row?.permissionTypes?.length > 0 && row.permissionTypes.map((act) => {
                            return <span className="Chip" key={act?.id}>{act?.permission_type?.toUpperCase()}</span>
                          })
                        }
                      </td>
                      <td>
                        {row?.effect}
                      </td>
                      <td className="TextRight ActionButtons">
                        <button className="BtnEdit" onClick={() => handleEditPermission(row)}>
                          <span className="BtnEditIcon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00561 1.63536C9.20207 1.43798 9.46476 1.33108 9.73589 1.33818C10.007 1.34527 10.2644 1.46578 10.4513 1.67319C10.6383 1.8806 10.7396 2.15792 10.7328 2.44414C10.7261 2.73037 10.612 3.00205 10.4155 3.19943L3.39142 10.2732L1.58134 10.5243L2.32338 8.33354L9.00497 1.63603L9.00561 1.63536ZM11.3681 0.750212C10.9495 0.286369 10.3737 0.0168296 9.76698 0.000761645C9.16031 -0.0153063 8.57239 0.22341 8.13228 0.664509L1.33906 7.4725C1.26705 7.54464 1.21209 7.63363 1.1786 7.73229L0.0369926 11.1048C0.000425229 11.2128 -0.00923985 11.329 0.00892428 11.4421C0.0270884 11.5552 0.0724725 11.6614 0.140724 11.7507C0.208976 11.84 0.297806 11.9092 0.398696 11.9518C0.499586 11.9944 0.609151 12.0089 0.716885 11.994L3.76118 11.5722C3.89453 11.5538 4.0189 11.4912 4.11635 11.3934L11.2901 4.16894C11.7297 3.72637 11.9848 3.1176 11.9993 2.47649C12.0139 1.83538 11.7872 1.21444 11.3681 0.750212ZM6.97735 10.6609C6.80914 10.6609 6.64782 10.7314 6.52888 10.857C6.40994 10.9826 6.34312 11.1529 6.34312 11.3304C6.34312 11.508 6.40994 11.6783 6.52888 11.8039C6.64782 11.9295 6.80914 12 6.97735 12H10.7827C10.9509 12 11.1122 11.9295 11.2312 11.8039C11.3501 11.6783 11.4169 11.508 11.4169 11.3304C11.4169 11.1529 11.3501 10.9826 11.2312 10.857C11.1122 10.7314 10.9509 10.6609 10.7827 10.6609H6.97735Z" fill="#404040" />
                            </svg>
                          </span>
                          Edit
                        </button>
                        <PopConfirm
                          message="Do you want to delete this rule?"
                          onConfirm={() => handleDeletePermission(row)}
                          onCancel={() => console.log("cancelled")}
                          okText="Delete"
                          cancelText="Cancel"
                        >
                          <button className="BtnDelete">
                            <FontAwesomeIcon icon={faTrashCan} />
                          </button>
                        </PopConfirm>
                      </td>
                    </tr>
                  })}
                </tbody>
              </table>

                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      totalCount={totalItems}
                      setCurrentPage={setCurrentPage}
                      setTotalPages={setTotalPages}
                      pageSize={itemsPerPage}
                    />
</div>


          </GroupRulesWrapper>
        </GroupDetailWrapper>
      </UserGroupMain>
    </>
  );
};

export default UserGroups;
